module.exports = __webpack_public_path__ + "img/playstore.357676fe.png";